import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-entity-details',
    templateUrl: './entity-details.component.html',
    styleUrls: ['./entity-details.component.scss'],
})
export class TableEntityDetailsComponent implements OnInit {

    @Input('data') config;

    constructor() { }

    ngOnInit() { }
    // Método para obter o nome do estado do Payshop
    getPayshopStatusName(status: number): string {
        switch (status) {
            case 0: return 'Pendente';
            case 1: return 'Aprovado';
            case 2: return 'Rejeitado';
            default: return 'Desconhecido';
        }
    }

    // Método para formatar o tamanho do ficheiro
    formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
}
